module.exports = __webpack_public_path__ + "img/remove_src_3.4e8bfee3.webp";